import { Subject_SubjectEnum } from '@protos/common/common.db_pb';

// =============================================================

export const getSubjectEnumFromStringEnum = (
  subjectParam?: string
): Subject_SubjectEnum | undefined => {
  if (!subjectParam) {
    return undefined;
  }
  const enumValue =
    Subject_SubjectEnum[
      subjectParam.trim().toUpperCase() as keyof typeof Subject_SubjectEnum
    ];

  return typeof enumValue === 'number' ? enumValue : undefined;
};

// =============================================================
